import React from 'react'
import styled from 'styled-components'


const Text = styled.h1`
position: fixed;
top: ${props => props.top};
left: ${props => props.left};
right: ${props => props.right};
color:${props => `rgba(${props.theme.textRgba},0.4)`};
font-size: clamp(3rem, 8vw, calc(5rem + 5vw));
z-index:0;
pointer-events: none;

@media (max-width: 50em) {
    font-size: clamp(2.25rem, 13vw, 4.5rem);
    color:${props => `rgba(${props.theme.textRgba},0.22)`};
}

`


const BigTitlte = (props) => {
    return (
        <Text  top={props.top}  left={props.left}  right={props.right}>
            {props.text}
        </Text>
    )
}

export default BigTitlte
